/**
 * constraintContext — session-scoped carrier for the Mission Control
 * "Current Opportunity" constraint (stage + leak % + expected recovery).
 *
 * Stored when the user lands on a modelling tool via the Current
 * Opportunity banner (ConstraintContextBanner), attached to every
 * scenario/solution save during the session so Compare Scenarios can
 * tag runs ("Recovers Behavior leak") and rank them by expected value
 * recovery. Cleared when the user dismisses the context banner.
 */
const KEY = 'mc_constraint_context';

export function storeConstraintContext(ctx) {
  try { sessionStorage.setItem(KEY, JSON.stringify(ctx)); } catch { /* storage unavailable */ }
}

export function getConstraintContext() {
  try {
    const v = JSON.parse(sessionStorage.getItem(KEY));
    return v && v.label && Number.isFinite(Number(v.leak)) ? v : null;
  } catch {
    return null;
  }
}

export function clearConstraintContext() {
  try { sessionStorage.removeItem(KEY); } catch { /* storage unavailable */ }
}
